import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {ToolbarModule} from 'primeng/toolbar';
import {DrawerModule} from 'primeng/drawer';
import {InputTextModule} from 'primeng/inputtext';
import {TextareaModule} from 'primeng/textarea';
import {SelectModule} from 'primeng/select';
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {AccordionModule} from 'primeng/accordion';
import {SkeletonModule} from 'primeng/skeleton';
import {WfBpmnCanvasComponent} from './component/wf-bpmn-canvas/wf-bpmn-canvas.component';
import {WfBpmnToolbarComponent} from './component/wf-bpmn-toolbar/wf-bpmn-toolbar.component';
import {WfBpmnPropertiesPanelComponent} from './component/wf-bpmn-properties-panel/wf-bpmn-properties-panel.component';
import {WfBpmnMinimapComponent} from './component/wf-bpmn-minimap/wf-bpmn-minimap.component';
import {WfBpmnDesignerComponent} from './wf-bpmn-designer/wf-bpmn-designer.component';

// Note: BPMN services (BpmnCanvasStateService, BpmnCommandService, BpmnSerializerService,
// BpmnLayoutService, BpmnValidationService) are provided at component level in
// WfBpmnDesignerComponent to ensure per-instance scoping. BpmnEdgeRouterService is
// stateless and also provided at component level for consistency.

@NgModule({
    declarations: [
        WfBpmnCanvasComponent,
        WfBpmnToolbarComponent,
        WfBpmnPropertiesPanelComponent,
        WfBpmnMinimapComponent,
        WfBpmnDesignerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        TooltipModule,
        ToolbarModule,
        DrawerModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        ToggleSwitchModule,
        AccordionModule,
        SkeletonModule,
    ],
    exports: [
        WfBpmnCanvasComponent,
        WfBpmnToolbarComponent,
        WfBpmnPropertiesPanelComponent,
        WfBpmnMinimapComponent,
        WfBpmnDesignerComponent,
    ],
})
export class BpmnEditorModule {
}
